import {
  Spacer,
  Tag,
  dateFormatterDayMonthYear,
  dateFormatterHourMinute,
} from "@qivia/ui";
import { typographies } from "@qivia/ui/src/styles/figmaTypographies";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { colors } from "@qivia/ui/src/styles/figmaColors";
import { PublicEmspCdrs } from "../../transactionsAPI";
import { authorizationStatusProps } from "../../lib";

export const SidePanelHeader = (props: { cdr: PublicEmspCdrs }) => {
  const { t } = useTranslation();

  const statusTranslated = t(
    `emspCdrs.authorizationStatus.${props.cdr.authorizationStatus}`,
  );

  const cdrStatus =
    authorizationStatusProps[
      statusTranslated as keyof typeof authorizationStatusProps
    ];

  return (
    <StyledPanelContainer>
      <Tag
        text={statusTranslated}
        backgroundColor={cdrStatus.backgroundColor}
        textColor={cdrStatus.textColor}
      />
      <Spacer y={1.5} />
      <StyledRowAmount>
        <StyledAmount>{props.cdr.totalCost.toFixed(2)}</StyledAmount>
        <StyledCurrency>
          {props.cdr.totalCost && (
            <>
              &nbsp;EUR <Spacer y={0.25} />
            </>
          )}
        </StyledCurrency>
      </StyledRowAmount>
      <Spacer y={1.5} />
      <StyledBodyM>{props.cdr.locationName}</StyledBodyM>
      <Spacer y={0.25} />
      <StyledDate>
        <div>{dateFormatterDayMonthYear(new Date(props.cdr.startAt))}</div>
        <div>
          {dateFormatterHourMinute(new Date(props.cdr.startAt)).replace(
            ":",
            "h",
          )}
          {" - "}
          {dateFormatterHourMinute(new Date(props.cdr.stopAt)).replace(
            ":",
            "h",
          )}
        </div>
      </StyledDate>
    </StyledPanelContainer>
  );
};

const StyledBodyM = styled.div`
  ${typographies["Body/M"]}
`;

const StyledPanelContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const StyledDate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  ${typographies["Body/XXS"]}
  color: ${colors["colors/text/darkGrey"]}
`;

const StyledRowAmount = styled.div`
  display: flex;
  align-items: flex-end;
`;

const StyledCurrency = styled.div`
  font-size: 1rem;
  font-style: normal;
  font-weight: 400;
`;

const StyledAmount = styled.div`
  font-size: 2.25rem;
  font-style: normal;
  font-weight: 400;
`;
